import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getPartnerDashboard } from "../../services";
import { showLoader, hideLoader } from "./LoaderSlice";

// Create async thunk for API calls
export const fetchPartnerDashboard = createAsyncThunk(
  "partnerDashboard/fetchPartnerDashboard",
  async (_, { dispatch }) => {
    dispatch(showLoader());
    try {
      const response = await getPartnerDashboard();
      dispatch(hideLoader());
      return response || [];
    } catch (error) {
      dispatch(hideLoader());
      console.log(error);
      throw error;
    }
  },
);

const initialState = {
  partnerList: [],
  isLoaded: false,
};

const partnerDashboardSlice = createSlice({
  name: "partnerDashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPartnerDashboard.pending, (state) => {
        state.isLoaded = false;
      })
      .addCase(fetchPartnerDashboard.fulfilled, (state, action) => {
        state.isLoaded = true;
        state.partnerList = action.payload;
      })
      .addCase(fetchPartnerDashboard.rejected, (state) => {
        state.isLoaded = true;
      });
  },
});

export default partnerDashboardSlice.reducer;
